import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ScoreKeyHit.styled';
import { CheckMark } from '../LegacySuccessIcon/LegacySuccessIcon';
import { CrossIcon } from '../LegacyFailIcon/LegacyFailIcon';
import { MinusIcon } from '../LegacyNeutralIcon/LegacyNeutralIcon';

const ScoreKeyHit = (props) => {
  // we don't want to render if it's a positive point objective with 0 calculated points (because it's already been hit)
  const positiveScoreObjectiveBut0Points =
    props.scoreMetadataWithCalculated.calculatedPoints === 0 &&
    props.scoreMetadataWithCalculated.points > 0;
  const getIcon = () => {
    if (props.scoreMetadataWithCalculated.key === 'neutral') {
      return <MinusIcon />;
    } else if (props.scoreMetadataWithCalculated.points > 0) {
      return <CheckMark />;
    }
    return <CrossIcon />;
  };
  return (
    <Styled.ScoreKeyHit
      className={props.className}
      scoreKey={props.scoreMetadataWithCalculated.key}
      points={props.scoreMetadataWithCalculated.calculatedPoints}
      $top={props.top}
      positiveScoreObjectiveBut0Points={positiveScoreObjectiveBut0Points}
    >
      {getIcon()} {props.scoreMetadataWithCalculated.label}
    </Styled.ScoreKeyHit>
  );
};

ScoreKeyHit.propTypes = {
  scoreMetadataWithCalculated: PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    points: PropTypes.number.isRequired,
    calculatedPoints: PropTypes.number.isRequired,
  }).isRequired,
  top: PropTypes.string,
  className: PropTypes.string,
};

export default ScoreKeyHit;
